<template>
	<div class="sign-up-detail">
		<div class="container">
			<!-- title -->
			<p class="apply-title">报名信息</p>
			<ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">机构：</span>
					<span class="a-info">{{data.agent_title}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">科目：</span>
					<span class="a-info">{{data.subject_title}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考次：</span>
					<span class="a-info">{{data.season_title}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">级别：</span>
					<span class="a-info">{{data.rank_req}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">免冠照片：</span>
					<span class="a-info">
						<img :src="data.photo_url" class="img" />
					</span>
				</li>
			</ul>
			<!-- title -->
			<hr />
			<!-- <p class="apply-title">缴费信息</p> -->
			<!-- 缴费信息 -->
			<!-- <ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">支付状态：</span>
					<span class="a-info" v-if="data.payment_state === 1">已支付</span>
					<span class="a-info" v-if="data.payment_state === 0">未支付</span>
				</li>
				<div v-if="data.payment_state === 1">
					<li class="item clearfix">
						<span class="a-title">支付订单号：</span>
						<span class="a-info">{{data.payment_order_no}}</span>
					</li>
					<li class="item clearfix">
						<span class="a-title">支付时间：</span>
						<span class="a-info">{{data.payment_time}}</span>
					</li>
					<li class="item clearfix">
						<span class="a-title">支付金额：</span>
						<span class="a-info">{{data.payment_money}}</span>
					</li>
					<li class="item clearfix">
						<span class="a-title">支付方式：</span>
						<span class="a-info" v-if="data.payment_plat === 1">支付宝</span>
						<span class="a-info" v-if="data.payment_plat === 10">微信</span>
						<span class="a-info" v-if="data.payment_plat === 20 ||data.payment_plat === 21 ">银联</span>
					</li>
				</div>
			</ul> -->
			<!-- title -->
			<hr />
			<p class="apply-title">考试信息</p>
			<!-- 考试信息 -->
			<ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">准考证号：</span>
					<span class="a-info">{{data.exam_number}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考试开始时间：</span>
					<span class="a-info">{{data.exam_start_time}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考试结束时间：</span>
					<span class="a-info">{{data.exam_end_time}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考试科目：</span>
					<span class="a-info">{{data.subject_title}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">考试级别：</span>
					<span class="a-info">{{data.rank_req}}</span>
				</li>
				<li class="item clearfix">
					<span class="a-title">所属考场：</span>
					<span class="a-info">{{data.region_title}}</span>
				</li>
				<!-- <li class="item clearfix">
					<span class="a-title">座位号：</span>
					<span class="a-info">{{data.seat_number}}</span>
				</li>-->
				<li class="item clearfix">
					<span class="a-title">考场地址：</span>
					<span class="a-info">{{data.region_address}}</span>
				</li>
			</ul>
			<hr />
			<p class="apply-title">考试结果</p>
			<!-- 考试信息 -->
			<ul class="a-list">
				<li class="item clearfix">
					<span class="a-title">成绩：</span>
					<span class="a-info" v-if="data.exam_result === 0">未录入</span>
					<span class="a-info" v-else-if="data.exam_result === 1">通过</span>
					<span class="a-info" v-else-if="data.exam_result === 2">通过</span>
					<span class="a-info" v-else-if="data.exam_result === -1">不通过</span>
					<span class="a-info" v-else-if="data.exam_result === -2">缺考</span>
					<span class="a-info" v-else>未录入</span>
				</li>
			</ul>
			<div class="btn-wrap">
				<el-button type="primary" class="btn" @click="$router.go(-1)">返回</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { signDetail } from "@/api/sign";
export default {
	data() {
		return {
			data: {}
		};
	},
	mounted() {
		this.signDetail();
	},
	methods: {
		signDetail() {
			signDetail(this.$route.params.id).then(res => {
				if (res && res.code === 200) {
					this.data = res.data;
				} else {
					this.$message.error(res.message);
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.sign-up-detail {
	.container {
		width: 828px;
		min-height: 362px;
		border: 1px solid #eaeaea;
		margin: 30px auto;
		margin-bottom: 80px;
		overflow: hidden;
	}
	.apply-title {
		font-size: 24px;
		color: #363636;
		margin-top: 45px;
		text-align: center;
	}
	.a-list {
		width: 684px;
		margin: 50px auto;
		.item {
			width: 100%;
			min-height: 46px;
			padding-top: 12px;
			padding-bottom: 15px;
			border-bottom: 1px solid #e7e7e7;
			.a-title {
				width: 80px;
				font-size: 14px;
				color: #363636;
				text-align: right;
				white-space: nowrap;
				float: left;
			}
			.a-info {
				width: 420px;
				padding-left: 15px;
				font-size: 14px;
				color: #7a7a7a;
				float: right;
				img {
					width: 122px;
					height: 156px;
				}
			}
		}
	}
	.btn-wrap {
		margin-bottom: 50px;
		overflow: hidden;
		text-align: center;
		.btn {
			width: 302px;
		}
	}
}
@media screen and (max-width: 768px) {
	.sign-up-detail {
		.container {
			width: 90%;
		}
		.a-list {
			width: 100%;
			.item {
				.a-info {
					width: calc(100% - 100px);
				}
			}
		}
		.btn-wrap {
			.btn {
				width: 60%;
			}
		}
	}
}
</style>
